import {
    AnswerOption,
    LookupResponse,
    CaseQuestionsAnswers,
    QuestionCriteria,
    QuestionDefinition,
} from 'types/createCase';
import { DynamicFormField } from 'types/formFields';
import { formatedDate } from 'utils/formatedDate';

type Props = {
    answerOptions: AnswerOption[] | undefined;
    formValues: Record<string, string>;
    lookUpOptions: LookupResponse[];
    questionCriteria: QuestionCriteria[] | undefined;
    questionDefinitions: QuestionDefinition[] | undefined;
    formFields: DynamicFormField[];
};

const getQuestionAnswerReqData = ({
    answerOptions,
    formValues,
    lookUpOptions,
    questionCriteria,
    questionDefinitions,
    formFields,
}: Props) => {
    if (!answerOptions || !questionCriteria || !questionDefinitions) return [];

    const result: CaseQuestionsAnswers[] = [];

    Object.keys(formValues).forEach((fieldName) => {
        const questionCriteriaItem = questionCriteria.find(
            (qCItem) => qCItem.questionId === fieldName
        );

        const questionDefinitionItem = questionDefinitions.find(
            (qDItem) => qDItem.id === fieldName
        );

        if (!questionDefinitionItem) return;

        const { displayOrder = 1, isRequired } = questionCriteriaItem || {};
        const { questionType } = questionDefinitionItem;

        const {
            lookupSource,
            name: questionText = '',
            target = null,
        } = questionDefinitionItem;

        const lookUpAnswer = lookUpOptions.find(
            (item) => item.id === formValues[fieldName]
        );

        const fieldAnswer = answerOptions.find(
            (aOItem) => aOItem.id === formValues[fieldName]
        );

        const { parentQuestionId = '' } =
            formFields?.find((item) => item.props.name === fieldName) || {};

        const answerValue =
            lookupSource && lookUpAnswer
                ? lookUpAnswer.id
                : fieldAnswer?.value || formValues[fieldName];

        const answerText =
            lookupSource && lookUpAnswer
                ? lookUpAnswer.name
                : fieldAnswer?.name || formValues[fieldName];

        if (!isRequired && !answerValue) return;

        const answerIsDate = questionType === 'date';

        const model: CaseQuestionsAnswers = {
            ...(!answerIsDate && { answerValue }),
            answerText:
                answerIsDate && answerText
                    ? formatedDate(answerText).toDate()
                    : answerText,
            displayOrder,
            questionId: fieldName,
            questionText,
            targetEntityAttribute: target,
            parentQuestionId,
            formValue: formValues[fieldName],
        };

        result.push(model);
    });

    return result;
};

export { getQuestionAnswerReqData };
